import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  color: #000000;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  padding: 3.2em 10%;
  align-items: center;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 2.25em 5%;
  }
  .visit {
    border: 1px solid #808080;
    background-color: #fcfcfc;
    border-radius: 8px;
    padding: 0.5em 1.1em;
    align-items: center;
    font-size: 12px;
    display: none;
    @media (max-width: ${({ theme }) => theme.mobile.md}) {
      display: flex;
    }

    h2 {
      font-size: 1em;
      font-weight: 700;
      cursor: pointer;
      margin-right: 0.6em;
      @media (max-width: ${({ theme }) => theme.mobile.md}) {
        font-size: 0.8em;
      }
    }
  }
`;
